import React, { useState, useEffect, useRef } from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';

const NetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBanner, setShowBanner] = useState(!navigator.onLine);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    
    const handleOnline = () => {
      if (mounted.current) {
        setIsOnline(true);
        // Show briefly that we're back online
        setTimeout(() => {
          if (mounted.current) setShowBanner(false);
        }, 2000);
      }
    };

    const handleOffline = () => {
      if (mounted.current) {
        setIsOnline(false);
        setShowBanner(true);
      }
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      mounted.current = false;
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showBanner) return null;

  return (
    <div 
      className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ${
        isOnline ? 'bg-green-500' : 'bg-red-500'
      }`}
    >
      <div className="max-w-lg mx-auto px-4 py-3 flex items-center justify-center gap-3">
        {isOnline ? (
          <>
            <RefreshCw className="w-5 h-5 text-white animate-spin" />
            <span className="text-white text-sm font-medium">
              Back online! Reconnecting...
            </span>
          </>
        ) : (
          <>
            <WifiOff className="w-5 h-5 text-white" />
            <div className="text-center">
              <p className="text-white text-sm font-medium">
                No internet connection
              </p>
              <p className="text-white/80 text-xs">
                Please check your connection to continue using CoupleIn
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default NetworkStatus;
